/** @prettier */
import { useEffect } from 'react';

/**
 * Hook that fires a callback on clicks outside of the passed ref(s)
 */
function useClickOutsideCallback({ refs = [{}], callback = () => {} }) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (refs.every((ref) => ref.current && !ref.current.contains(event.target))) {
        callback();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [refs]);
}

export default useClickOutsideCallback;
